/**
 * Created by elmer on 28/03/17.
 */
export default {
  i: {
    select: {
      placeholder: 'Seleccione una opción',
      noMatch: 'No se encontraron resultados',
      loading: 'Cargando',
    },
    table: {
      noDataText: 'No hay datos que mostrar',
      noFilteredDataText: 'No se encontraron resultados',
      confirmFilter: 'Confirmar',
      resetFilter: 'Reiniciar',
      clearFilter: 'Todos',
    },
    datepicker: {
      selectDate: 'Seleccione la fecha',
      selectTime: 'Seleccione la hora',
      startTime: 'Hora de inicio',
      endTime: 'Hora de término',
      clear: 'Limpiar',
      ok: 'OK',
      month: '',
      month1: 'Enero',
      month2: 'Febrero',
      month3: 'Marzo',
      month4: 'Abril',
      month5: 'Mayo',
      month6: 'Junio',
      month7: 'Julio',
      month8: 'Agosto',
      month9: 'Septiembre',
      month10: 'Octubre',
      month11: 'Noviembre',
      month12: 'Diciembre',
      year: '',
      weeks: {
        sun: 'Dom',
        mon: 'Lun',
        tue: 'Mar',
        wed: 'Mie',
        thu: 'Jue',
        fri: 'Vie',
        sat: 'Sab',
      },
      months: {
        m1: 'Ene',
        m2: 'Feb',
        m3: 'Mar',
        m4: 'Abr',
        m5: 'May',
        m6: 'Jun',
        m7: 'Jul',
        m8: 'Ago',
        m9: 'Sep',
        m10: 'Oct',
        m11: 'Nov',
        m12: 'Dic',
      },
    },
    transfer: {
      titles: {
        source: 'Source',
        target: 'Target',
      },
      filterPlaceholder: 'Search here',
      notFoundText: 'Not Found',
    },
    modal: {
      okText: 'OK',
      cancelText: 'Cancel',
    },
    poptip: {
      okText: 'OK',
      cancelText: 'Cancel',
    },
    page: {
      prev: 'Previous Page',
      next: 'Next Page',
      total: 'Total',
      item: 'item',
      items: 'items',
      prev5: 'Previous 5 Pages',
      next5: 'Next 5 Pages',
      page: '/page',
      goto: 'Goto',
      p: '',
    },
    rate: {
      star: 'Star',
      stars: 'Stars',
    },
    tree: {
      emptyText: 'No Data',
    },
  },
};



// WEBPACK FOOTER //
// ./src/locale/es-ES.js